import React,{useEffect} from "react";
import { Route, Navigate } from "react-router-dom";

import withRegistrationHeader from "@layout/withRegistrationHeader";
import withHeader from "@layout/withHeader";
import withHeaderAndFooter from "@layout/withHeaderAndFooter";
import withPlainHeader from "@layout/withPlainHeader";
import withLRIntegrationHeader from "@layout/withLRIntegrationHeader";
import withWhiteBgLogo from "@layout/withWhiteBgLogo";
import LayoutWrapper from "@layout/LayoutWrapper";
const LAYOUTS = {
  withLRIntegrationHeader,
  withRegistrationHeader,
  withHeaderAndFooter,
  withHeader,
  withPlainHeader,
  withWhiteBgLogo
}
const withLayout = (layout='default',Component,opt,props)=>{
  const args = [Component];
  opt && args.push(opt);
  const LayComponent = LAYOUTS[layout]?LAYOUTS[layout](...args):Component;
  return <LayComponent {...props}/>
}
export const LoginRoute = ({ component,hasChildRoutes, onRouteChange,postLoginRoute,isLoggedIn, path, redirectTo,layout,layoutOpt,componentOpts,...props}) => {
  if (isLoggedIn) {
    !hasChildRoutes && onRouteChange(path,isLoggedIn);
    return withLayout(layout,component,layoutOpt,{...componentOpts,path});
  }
  const to = {pathname: redirectTo, state:{from: path} };
  postLoginRoute && (to.search = `?redirect_to=${path}`);
  //console.log('Redirect to home',isLoggedIn,path);
  return <Navigate to={to} />;
};

export const NonLoginRoute = ({ component, onRouteChange,hasChildRoutes, path, isLoggedIn, redirectTo,layout,layoutOpt,...props}) => {
  if (!isLoggedIn) {
    !hasChildRoutes && onRouteChange(path,isLoggedIn);
    return withLayout(layout,component,layoutOpt,{path});
  }
  //console.log('Redirect to Login',isLoggedIn,path);
  return <Navigate to={{pathname: redirectTo, state:{from: path} }} />;
};
export const ChildRoute = ({component:Comp, onRouteChange,isLoggedIn,path,...props})=>{
  onRouteChange(path || location.pathname,isLoggedIn);
  return <LayoutWrapper childRoute pageRoute={false} path={path}><Comp {...props}/></LayoutWrapper>
}
const PrivateRoute = ({ authRequired,...props})=>{
  const Comp = authRequired?LoginRoute:NonLoginRoute;
  return <Comp {...props}/>
}
export default PrivateRoute;
